import { render, staticRenderFns } from "./LhbDetailContent.vue?vue&type=template&id=ebce715a&scoped=true"
import script from "./LhbDetailContent.vue?vue&type=script&lang=js"
export * from "./LhbDetailContent.vue?vue&type=script&lang=js"
import style0 from "./LhbDetailContent.vue?vue&type=style&index=0&id=ebce715a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebce715a",
  null
  
)

export default component.exports